import { render } from "./follow.vue?vue&type=template&id=71188574&scoped=true&ts=true"
import script from "./follow.vue?vue&type=script&lang=ts"
export * from "./follow.vue?vue&type=script&lang=ts"

import "./follow.vue?vue&type=style&index=0&id=71188574&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71188574"]])

export default __exports__